export default __webpack_public_path__ + "static/media/lista_paquete.965606cc.svg";